module.exports = __webpack_public_path__ + "static/media/sloga-slider-mobile.241aec28.png";